<template>
  <div class="home_view">
    <div class="banner">
      <div class="swiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in bannerList"
            :key="index"
          >
            <img :src="item.url" alt="" />
          </div>
        </div>
        <div class="swiper-button-prev" v-show="swiperIsHover">
          <img src="@/assets/imgs/left.png" alt="" />
        </div>
        <div class="swiper-button-next" v-show="swiperIsHover">
          <img src="@/assets/imgs/right.png" alt="" />
        </div>

        <div class="swiper-pagination" v-show="swiperIsHover"></div>
      </div>
    </div>
    <div class="fixTab c">
      <div
        class="li"
        v-for="(item, index) in fixTabList"
        :key="index"
        @click="fixToView(item)"
        v-show="item.isShow"
      >
        <img class="left_img" :src="item.imgSrc" alt="" />
        <div
          class="right_txt"
          :class="index < (fixTabList[4].isShow ? 4 : 3) ? 'line_right' : ''"
        >
          <h3>
            {{ item.title }}
            <div
              v-if="getName(item.title)"
              :style="{ backgroundColor: getColor(item.title) }"
              class="right_box"
            >
              {{ getName(item.title) }}
            </div>
          </h3>
          <p>{{ item.content }}</p>
        </div>
      </div>
    </div>

    <!-- 热门测试项目 -->
    <div class="test_audition c" id="1">
      <allHead
        :title="'热门测试项目'"
        backgroundText="POPULAR PROJECTS"
        marginBottom="7px"
      />
      <div class="audition_content">
        <div
          class="audition_item"
          v-for="(item, index) in auditionList"
          :key="index"
          @click="toView(`/details/${item.id}`)"
        >
          <div class="text">
            已预约<span class="orange_text">{{ item.buyCount }}</span
            >次<span class="line"></span>满意度<span class="orange_text"
              >{{ item.grade }}%</span
            >
          </div>
          <div class="img">
            <xl-img
              v-if="item.cartoonImg && item.cartoonImg != '[]'"
              :src="item.cartoonImg"
            ></xl-img>
            <xl-img v-else :src="item.original"></xl-img>
          </div>
          <div class="content">
            <div class="goods_name single_omission">{{ item.name }}</div>
            <div class="introductory single_omission">
              {{ item.introductory ? item.introductory : '暂无简介' }}
            </div>
            <div
              class="submit_btn"
              @click="toView(`/placeOrderView/${item.id}`)"
            >
              立即预约
            </div>
          </div>

          <div
            v-if="item.signature"
            :style="{ backgroundColor: item.color }"
            class="right_box"
          >
            {{ item.signature }}
          </div>
        </div>
      </div>
    </div>

    <!-- 名师课堂 -->
    <div class="expert_comments c" id="2">
      <allHead title="学研云课堂" backgroundText="CLOUD CLASSROOM" />
      <div class="content">
        <div class="content_item" v-for="item in lectureList" :key="item.id">
          <div class="top" @click="showVideo(item)">
            <img :src="item.cover" alt="" />
            <div class="play">
              <img src="@/assets/imgs/play.png" alt="" />
            </div>
          </div>
          <div class="bottom">
            <div class="info">
              <div class="face">
                <xl-img :src="item.dep.face" alt="" />
              </div>
              <div class="text">
                <div class="name">{{ item.dep.name }}</div>
                <div class="theme overElli">主题：{{ item.name }}</div>
              </div>
            </div>
            <div class="dep">
              <p v-for="(i, ix) in item.dep.depList" :key="ix">
                <!-- <span class="icon"></span> -->
                <span class="text">{{ i.text }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="blue_text" v-if="!viewMore && resLectureList.length > 4">
        <span @click="viewMore = true">点击查看更多</span>
        <img src="../../assets/image/home/icon_bottom.png" alt="" />
      </div>
    </div>

    <!-- 论文致谢 -->
    <div class="thesis_thanks c" id="3">
      <allHead
        title="论文致谢"
        backgroundText="ACKNOWLEDGEMENTS"
        marginBottom="13px"
      />
      <div class="cs_box">论文致谢最高奖励2000元红包，致谢学研汇好礼送不停</div>
      <el-table
        ref="singleTable"
        :data="recordsList"
        :header-style="{ backgroundColor: '#E8F0FC' }"
        style="width: 100%; height: 460px"
      >
        <el-table-column
          property="thesisName"
          label="影响因子/期刊"
          align="center"
        >
          <template #default="{ row }">
            <div class="table_title" style="color: #f59a23">
              {{ row.factor }}
            </div>
            <div class="table_title">
              {{ capitalizeFirstLetter(row.thesisName) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="author" label="作者" align="center">
          <template #default="{ row }">
            <span class="table_title">
              {{ maskString(row.author) }}
            </span>
            <span style="color: #a9a7b1">（{{ row.unit }}）</span>
          </template>
        </el-table-column>
        <el-table-column property="thesisUrl" label="原文链接" align="center">
          <template #default="{ row }">
            <div class="table_title" style="text-align: left">
              {{ row.thesisUrl }}
              <span
                @click="toActicel(row.thesisUrl)"
                class="table_title"
                style="color: #056de8; cursor: pointer"
                >查看原文</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          property="thesisContent"
          label="致谢内容"
          align="center"
        >
          <template #default="{ row }">
            <div class="all_qian">
              {{ row.thesisContent }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 用户之声 -->
    <div class="voice_customer" id="4">
      <allHead title="用户之声" backgroundText="USER VOICE" />
      <div class="content c">
        <div class="li">
          <div class="con">
            <img src="../../assets/image/home/yhzs_1.png" alt="" />
            <div class="title">高效</div>
          </div>
        </div>
        <div class="li li2">
          <div class="con">
            <img src="../../assets/image/home/yhzs_2.png" alt="" />
            <div class="title">专业</div>
          </div>
        </div>
        <div class="li li3">
          <div class="con">
            <img src="../../assets/image/home/yhzs_3.png" alt="" />
            <div class="title">服务</div>
          </div>
        </div>
      </div>

      <div
        class="danmaku_box"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <vue-danmaku
          ref="danmaku"
          :danmus="voiceList"
          :channels="3"
          :speeds="150"
          loop
          useSlot
          style="height: 460px; width: 100%"
          :randomChannel="true"
        >
          <template v-slot:dm="{ danmu }">
            <div class="danmaku-item">
              <div class="danmaku-content">
                <div class="top">
                  <span class="name">{{ danmu.memberName }}</span>
                  <span class="gender">{{ danmu.goodsName }}</span>
                </div>
                <div class="text">{{ danmu.evaluate }}</div>
              </div>
            </div>
          </template>
        </vue-danmaku>
      </div>
    </div>

    <div class="navigation_box_top">
      <div class="fix_title">
        <span>页面导航</span>
        <img src="../../assets/image/all/right.png" alt="" />
      </div>
      <div class="navigation_box">
        <div class="li li_title">首页导航</div>
        <div
          v-for="item in navigationList"
          :key="item.id"
          class="li"
          :class="navigationValue == item.id ? 'li_active' : ''"
          @click="navigationChange(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>

    <video-dialog
      :visible="videoDialogVisible"
      :activeVideo="activeVideo"
      @closeDialog="closeDialog"
    ></video-dialog>
  </div>
</template>

<script>
import { getActivateActivity } from '@/api/referralEarnings'
import vueDanmaku from 'vue-danmaku'
import 'swiper/swiper-bundle.min.css' // 所有 Swiper 样式，包括所有模块样式（如导航、分页等）
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper' // 导入您需要的模块
import {
  getBanner,
  getTestSelect,
  getVideoList,
  getVoiceList,
  getThesisThanks,
} from '@/api/home'
import { checkLogin } from '@/tool'
import { mapState } from 'vuex'
import XlImg from '@/components/xyhComps/Xl-img.vue'
import VideoDialog from '@/components/dialogComponents/videoDialog.vue'
import { getWebTag } from '@/api/goods'

export default {
  components: { XlImg, VideoDialog, vueDanmaku },
  data() {
    return {
      danmus: [
        { name: '张三', gender: '男', text: '这是弹幕内容1' },
        { name: '李四', gender: '女', text: '这是弹幕内容2' },
        { name: '王五', gender: '男', text: '这是弹幕内容3' },
      ],
      viewMore: false,
      date: 16677600000,
      swiperIsHover: false, //是否显示轮播图的左右按钮和小圆点
      activeVideo: {},
      timeData: {
        h: '',
        m: '',
        s: '',
      },
      videoDialogVisible: false,
      // 热门测试数组
      auditionList: [],
      resLectureList: [],
      bannerList: [],
      checkLogin,
      //线下数据
      offlineThesisThanks: [
        {
          id: '20',
          author: '余嘉栋',
          unit: '清华大学',
          status: 'CHECK_SUCCESS',
          thesisName: 'Nature Communications',
          factor: '14.7',
          thesisContent:
            ' The authors  thank Shuo Li from Xueyanhui ScientificResearchPlatfrom(www.xueyanhui.com) for the XPS analysis',
          thesisUrl: 'https://doi.org/10.1038/s41467-025-57857-9',
          remark: '清华大学-余嘉栋',
          createTime: '2025-05-06 15:32:05',
        },
        {
          id: '19',
          author: '何剑月',
          unit: '西安交通大学',
          status: 'CHECK_SUCCESS',
          thesisName: 'Advanced Materials',
          factor: '27.4',
          thesisContent:
            ' The authors thank Shuo Li from Xueyanhui Scientific Research Platform (www.xueyanhui.com) for the variable-temperature UV–vis absorption spectra.',
          thesisUrl: ' https://doi.org/10.1002/adma.202406882',
          remark: '西安交通大学-何剑月',
          createTime: '2025-05-06 15:32:05',
        },
        {
          id: '18',
          author: '张立浩',
          unit: '桂林理工大学',

          status: 'CHECK_SUCCESS',
          title:
            'Synergistically enhancing nitrate reduction \ninto N2 in water by N-doped Pd–Cu biochar \nbimetallic single-atom electrocatalysis',
          thesisName: 'Biochar',
          factor: '13.1',
          thesisContent:
            'The authors Xueyanhui institution for the XAS char\nacterization and the DFT calculation respectively in our research.',
          thesisUrl: 'https://doi.org/10.1007/s42773-023-00298-8',
          remark: '桂林理工大学-张立浩',
          createTime: '2025-05-06 15:32:05',
        },
        {
          id: '17',
          author: '王红玉',
          unit: '中国科学院长春应用化学研究所',
          status: 'CHECK_SUCCESS',
          title:
            'A morphologically transformable hypoxia\ninduced radical anion for tumor-specific\n photothermal therapy',
          thesisName: 'Acta Pharmaceutica Sinica B',
          factor: '14.903',
          thesisContent:
            'We are grateful to Xueyanhui Scientific Research Platform for help in characterizing EPR.',
          thesisUrl: ' https://doi.org/10.1016/j.apsb.2024.09.017',
          remark: '中国科学院长春应用化学研究所-王红玉',
          createTime: '2025-05-06 15:32:05',
        },
        {
          id: '16',
          author: '王枫亮',
          unit: '华南理工大学',
          status: 'CHECK_SUCCESS',
          title:
            'Three-dimensional ordered macroporous nitrogen-doped carbon for efficient adsorption of flavonoids from plant extraction',
          thesisName: 'Chemical Engineering Journal',
          factor: '13.3',
          thesisContent:
            'The authors thank Xueyanhui (www.xueyanhui.com) for the XPS  analysis.',
          thesisUrl: 'https://doi.org/10.1016/j.cej.2024.158609',
          remark: '华南理工大学-王枫亮',
          createTime: '2025-05-06 15:32:05',
        },
        {
          id: '15',
          author: '刘琼',
          unit: '广东省科学院分析研究所',
          status: 'CHECK_SUCCESS',
          title:
            'Engineering atomic Rb-N configurations to tune radical \npathways for highly selective photocatalytic H2O2 synthesis \ncoupled with biomass valorization',
          thesisName: 'Journal of Energy Chemistry',
          factor: '14',
          thesisContent:
            'The authors thank Xueyanhui \n(www.xueyanhui.com) for XPS characterization.',
          thesisUrl: 'https://doi.org/10.1016/j.jechem.2024.08.045',
          remark: '广东省科学院分析研究所-刘琼',
          createTime: '2025-05-06 15:32:05',
        },
        {
          id: '14',
          author: '刘琼',
          unit: '广东省科学院分析研究所',
          status: 'CHECK_SUCCESS',
          title:
            'Constructing ultralow-loading Cu single atoms/Fe2O3 particles on Nb2C  MXenes for efficient utilization of atomic H to boost \nelectrochemical debromination',
          thesisName: 'Chemical Engineering Journal',
          factor: '13.3',
          thesisContent:
            'The authors thank Xueyanhui (www.xueyanhui.com) for TEM analysis.',
          thesisUrl: 'https://doi.org/10.1016/j.cej.2024.155550',
          remark: '广东省科学院分析研究所-刘琼',
          createTime: '2025-05-06 15:32:05',
        },
        {
          id: '13',
          author: '韩美胜',
          unit: '南方科技大学',
          status: 'CHECK_SUCCESS',
          title:
            'Air and Thermally Stable Fluoride Bridged Rare-Earth Clusters Showing Intense Photoluminescence and Potential LED Application',
          thesisName: 'Advanced Materials',
          factor: '27.4',
          thesisUrl:
            'https://advanced.onlinelibrary.wiley.com/doi/10.1002/adma.202406882',
          remark: '南方科技大学-韩美胜',
          createTime: '2025-05-06 15:32:05',
        },
        {
          id: '12',
          author: '韩美胜',
          unit: '南方科技大学',
          status: 'CHECK_SUCCESS',
          title:
            'Investigations of Mechanisms Leading to Capacity Differences in Li/Na/K-Ion Batteries with Conversion-Type Transition-Metal Sulfides Anodes',
          thesisName: 'Advanced Science',
          factor: '14.3',
          thesisContent:
            'The authors thank Xueyan hui (www.xueyanhui.com) for plotting the diagrams of ion-electron decou pling storage.',
          thesisUrl: 'https://doi.org/10.1002/advs.202410653',
          remark: '南方科技大学-韩美胜',
          createTime: '2025-05-06 15:32:05',
        },
        {
          id: '11',
          author: '韩美胜',
          unit: '南方科技大学',
          status: 'CHECK_SUCCESS',
          title:
            ' Hollow Microsphere Structure and Spin-Polarized Surface Capacitance Endow Ultrafine Fe7S8 Nanocrystals with Excellent Fast-Charging Capability in Wide-Temperature-Range Lithium-Ion Batteries',
          thesisName: 'advanced energy materials',
          factor: '27.8',
          thesisContent:
            ' The authors also acknowledge the technical support\n from SUSTech Core Research Facilities. The authors thank Xueyanhui  (www.xueyanhui.com) for plotting the synthesis diagrams and testing TEM.',
          thesisUrl:
            'https://onlinelibrary.wiley.com/doi/10.1002/aenm.202403851',
          remark: '南方科技大学-韩美胜',
          createTime: '2025-05-06 15:32:05',
        },
      ],
      navigationList: [
        {
          id: 1,
          name: '热门测试',
        },
        {
          id: 2,
          name: '名师课堂',
        },
        {
          id: 3,
          name: '论文致谢',
        },
        {
          id: 4,
          name: '用户之声',
        },
      ],
      navigationValue: 0,

      fixTabList: [
        {
          imgSrc: require('../../assets/image/home/fixtab_1.png'),
          title: '学研汇VIP',
          content: '首样免费测/先测试后付费',
          path: '',
          isShow: true,
        },
        {
          imgSrc: require('../../assets/image/home/fixtab_2.png'),
          title: '预存特惠',
          content: '最高增值10%元',
          path: 'deposit',
          isShow: true,
        },
        {
          imgSrc: require('../../assets/image/home/fixtab_3.png'),
          title: '团队中心',
          content: '统一报账|高效管理|福利升级',
          path: '',
          isShow: true,
        },
        {
          imgSrc: require('../../assets/image/home/fixtab_4.png'),
          title: '论文致谢',
          content: '最高奖励2000元',
          path: 'paperThank',
          isShow: true,
        },
        {
          imgSrc: require('../../assets/image/home/fixtab_5.png'),
          title: '邀请有礼',
          content: '现金奖励不封顶',
          path: '/myCenter/referralEarnings',
          isShow: true,
        },
      ],
      recordsList: [],
      pageData: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      voiceList: [],
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 启动拼团倒计时
    this.Time()
    this.getData()
    this.getVoiceList()
    this.getWebTagList()

    const tableBody = document.querySelector('.el-table__body-wrapper')

    tableBody.style.setProperty('--scroll-time', `1s`)

    tableBody.addEventListener('mouseenter', () => {
      tableBody.classList.add('paused')
    })
    tableBody.addEventListener('mouseleave', () => {
      tableBody.classList.remove('paused')
    })

    getActivateActivity().then((res) => {
      this.fixTabList.forEach((item) => {
        if (item.title == '邀请有礼') {
          item.isShow = !!res
        }
      })
    })
  },
  computed: {
    ...mapState('user', ['userInfo', 'teamInfo']),
    // 名家讲坛
    lectureList() {
      let arr = []
      if (this.viewMore) {
        arr = this.resLectureList
      } else {
        arr = this.resLectureList.slice(0, 4)
      }
      return arr
    },
  },
  methods: {
    capitalizeFirstLetter(str) {
      if (!str) return str
      return str
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    },
    handleMouseEnter() {
      this.$refs.danmaku.pause() // 鼠标移入时暂停弹幕
    },
    handleMouseLeave() {
      this.$refs.danmaku.play() // 鼠标移出时继续播放弹幕
    },
    getWebTagList() {
      getWebTag().then((res) => {
        this.tagList = res
      })
    },
    getName(val) {
      if (this.tagList && this.tagList.length > 0) {
        const item = this.tagList.find((item) => item.module === val)
        return item ? item.tag : null
      }
    },
    getColor(val) {
      if (this.tagList && this.tagList.length > 0) {
        const item = this.tagList.find((item) => item.module === val)
        return item ? item.color : null
      }
    },
    getVoiceList() {
      getVoiceList().then((res) => {
        this.voiceList = res
      })
    },
    end() {
      console.log(this.$refs.danmaku)
    },
    getData() {
      const tableBody = document.querySelector('.el-table__body-wrapper')
      getThesisThanks(this.pageData).then((res) => {
        res = res.concat(this.offlineThesisThanks)
        this.recordsList = res.concat(...Array(4).fill(res))
        tableBody.style.setProperty(
          '--scroll-time',
          `${this.recordsList.length}s`
        )
      })
    },
    navigationChange(val) {
      this.navigationValue = val.id
      const element = document.getElementById(val.id)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    // 初始化获取数据
    init() {
      this.getBanner()
      this.getTestSelect()
      this.getVideoList()
    },
    jump({ realIndex }) {
      let item = this.bannerList[realIndex]
      if (item && item.redirectUrl) {
        location.href = item.redirectUrl
      }
    },
    countDown() {
      let h = parseInt(this.date / (60 * 60))
      h = h < 10 ? '0' + h : h
      let m = parseInt((this.date / 60) % 60)
      m = m < 10 ? '0' + m : m
      let s = parseInt(this.date % 60)
      s = s < 10 ? '0' + s : s
      this.timeData = { h, m, s }
    },
    Time() {
      setInterval(() => {
        this.date -= 1
        this.countDown()
      }, 1000)
    },
    closeDialog() {
      this.videoDialogVisible = false
    },
    getVideoList() {
      getVideoList({ type: 'PRO_FORUM' }).then((res) => {
        this.resLectureList = res.map((i) => {
          i.dep = JSON.parse(i.dep)
          return i
        })
      })
    },
    // 打开视频播放弹窗
    showVideo(item) {
      this.activeVideo = item
      this.videoDialogVisible = true
    },
    // 跳转页面
    toView(path) {
      this.$router.push(path)
    },
    fixToView(item) {
      if (item.title == '学研汇VIP') {
        if (this.userInfo.role == 'BUYER' || !this.userInfo.role) {
          this.toView('/understandMember')
        } else {
          this.toView('/memberCenter')
        }
      } else if (item.title == '团队中心') {
        if (this.isJoinTeam()) {
          this.toView('/myCenter/myTeam')
        } else {
          this.toView('/teamCenter')
        }
      } else {
        this.toView(item.path)
      }
    },
    isJoinTeam() {
      return this.teamInfo.id ? true : false
    },
    // 获取banner
    async getBanner() {
      let data = await getBanner()
      this.bannerList = data
      this.$nextTick(() => {
        let that = this
        // 轮播图
        let swiper = new Swiper('.swiper', {
          speed: 400,
          spaceBetween: 100,
          observer: true,
          observeParents: true,
          loop: true,
          autoplay: {
            delay: 3000,
          },
          // loop: true,
          modules: [Navigation, Pagination, Scrollbar, Autoplay],
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          on: {
            click: this.jump,
          },
        })
        //鼠标覆盖停止自动切换
        swiper.el.onmouseover = function () {
          swiper.autoplay.stop()
          that.swiperIsHover = true
        }

        //鼠标离开开始自动切换
        swiper.el.onmouseout = function () {
          swiper.autoplay.start()
          that.swiperIsHover = false
        }
      })
    },
    // 获取热门测试
    async getTestSelect() {
      let data = await getTestSelect()
      this.auditionList = data
      this.auditionList.forEach((i) => {
        i.original = JSON.parse(i.original)
      })
    },

    toActicel(val) {
      window.open(val)
    },

    maskString(str, showLength = 1) {
      // 处理空值或非字符串类型
      if (!str || typeof str !== 'string') {
        return ''
      }

      // 去除前后空格
      const trimmedStr = str.trim()

      // 字符串长度小于保留长度时，直接返回
      if (trimmedStr.length <= showLength) {
        return trimmedStr
      }

      // 保留前showLength个字符，其余转星号
      const firstPart = trimmedStr.slice(0, showLength)
      const maskPart = '*'.repeat(trimmedStr.length - showLength)

      return firstPart + maskPart
    },
  },
}
</script>

<style lang="less" scoped>
.home_view {
  background-color: #f8f8f8;
  // 1.banner区域
  .banner {
    width: 100%;
    // height: 440px;
    // height: 580px;
    height: 400px;
    .swiper {
      height: 100%;
      .swiper-slide {
        img {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }
    }
  }
  .fixTab {
    position: relative;
    top: -30px;
    margin: 0 auto;
    z-index: 300;
    display: flex;
    // width: 100%;
    height: 116px;
    background: #ffffff;
    box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.05);
    border-radius: 12px;
    font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;
    font-weight: normal;
    width: 1474px;
    .li {
      position: relative;
      width: 25%;
      display: flex;
      align-items: center;
      padding-left: 15px;
      cursor: pointer;
      .left_img {
        width: 72px;
        height: 72px;
        margin-right: 5px;
      }
      .right_txt {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;

        h3 {
          display: flex;
          align-items: center;
          color: #100926;
          font-size: 18px;
          margin-bottom: 8px;
        }
        p {
          color: rgba(16, 9, 38, 0.4);
          font-size: 14px;
        }
      }
      .right_box {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 9px;
        height: 28px;
        background: #ff4a4a;
        border-radius: 6px 6px 6px 6px;
        font-size: 13px;
        color: #ffffff;
        margin-left: 6px;
      }
    }
    .line_right::after {
      position: absolute;
      right: 0;
      content: ''; /* 伪元素必须有 content 属性，即使为空 */
      height: 54px;
      border-right: 1.2px solid #000;
      opacity: 0.2;
    }
  }

  // 2.热门测试项目
  .test_audition {
    margin-top: -35px;
    .audition_content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .audition_item {
      width: 286px;
      height: 296px;
      position: relative;
      position: relative;
      background-color: #fff;
      padding: 12px;
      cursor: pointer;
      box-shadow: 0px 12 32px 0px rgba(11, 6, 30, 0.05);
      border-radius: 20px 20px 20px 20px;
      border: 2px solid transparent;
      padding-bottom: 30px;
      margin-top: 25px;
      .img {
        width: 100%;
        height: 144px;
        text-align: center;
        img {
          max-width: 144px;
        }
      }
      .text {
        font-size: 13px;
        color: #acacac;
        display: flex;
        align-items: center;
        justify-content: start;
        font-weight: normal;
        font-size: 14px;
        color: #a6a6a6;
        text-align: left;
        font-style: normal;
        .line {
          display: inline-block;
          height: 16px;
          width: 1px;
          background-color: #acacac;
          margin: 0 12px;
        }
        .orange_text {
          color: #ffa745;
        }
      }
      .content {
        width: 100%;
        position: absolute;
        bottom: 8px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        .goods_name {
          font-weight: bold;
          font-size: 20px;
          color: #100926;
          width: 100%;
          padding: 0 10px;
          height: 35px;
        }
        .introductory {
          color: @main-color;
          padding: 0 12px;
          width: 100%;
          font-weight: normal;
          height: 35px;
        }
        .submit_btn {
          width: 126px;
          height: 35px;
          line-height: 35px;
          display: none;
          margin-left: 0;
          font-size: 20px;
        }
      }
    }
    .right_box {
      position: absolute;
      top: -8px;
      right: -11px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 4px;
      height: 24px;
      background: #00ba38;
      border-radius: 6px 6px 6px 6px;
      font-size: 13px;
      color: #ffffff;
    }
    .audition_item:hover {
      border: 2px solid #056de8;
      box-shadow: 0px 0px 14px 7px rgba(5, 109, 232, 0.15);

      .content {
        .goods_name {
        }
        .introductory {
          display: none;
        }
        .submit_btn {
          display: block;
        }
        .text {
          display: none;
        }
      }
    }
    .audition_item:nth-child(4n) {
      margin-right: 0;
    }
    .last_item {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: @main-color;
      font-size: 32px;
      font-weight: 700;
      color: @main-color;
      background: rgba(5, 109, 232, 0.08);
    }
  }

  // 3.名师课堂
  .expert_comments {
    .content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .content_item {
        // width: 23.5%;
        width: 287px;
        height: 422px;
        background-color: #fff;
        margin-bottom: 24px;
        overflow: hidden;
        background: #ffffff;
        box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.05);
        border-radius: 20px 20px 20px 20px;
        .top {
          width: 100%;
          height: 180px;
          position: relative;
          cursor: pointer;
          img {
            width: 287px;
            height: 180px;
            object-fit: fill;
          }
          .play {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            img {
              width: 45px;
              height: 45px;
            }
          }
        }
        .bottom {
          width: 100%;
          height: 236px;
          // background-image: url(@/assets/imgs/bg1.png);
          background-size: cover;
          padding: 20px;
          padding-right: 4px;
          overflow: hidden;
          color: #000;
          .info {
            display: flex;
            align-items: center;
            height: 85px;
            .face {
              width: 60px;
              height: 60px;
              border-radius: 50%;
              overflow: hidden;
              flex-shrink: 0;
              margin-right: 12px;
              .xl-img {
                max-width: 100%;
              }
            }
            .text {
              text-align: left;
              // color: @main-color;
              .name {
                font-size: 22px;
                font-weight: bold;
                margin-bottom: 4px;
              }
              .theme {
                font-weight: bold;
                font-size: 16px;
              }
              .overElli {
                width: 183px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
              }
            }
          }
          .dep {
            color: #474747;
            p {
              font-size: 14px;
              text-align: left;
              margin-bottom: 6px;
              position: relative;
              // padding-left: 14px;
              padding-right: 14px;
              line-height: 18px;
              .icon {
                position: absolute;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: #474747;
                left: 0;
                top: 4px;
              }
              .text {
                line-height: 14px;
                // color: #474747;
                color: rgba(16, 9, 38, 0.5);
              }
            }
          }
        }
      }
    }
  }

  // 4.论文致谢
  .thesis_thanks {
    margin-top: -24px;
    .cs_box {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: normal;
      margin: 0 auto;
      font-size: 16px;
      color: #ffffff;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      width: 684px;
      height: 38px;
      margin-bottom: 40px;
      background: linear-gradient(
        90deg,
        rgba(5, 109, 232, 0) 0%,
        #056de8 50%,
        rgba(5, 109, 232, 0) 100%
      );
      border-radius: 0px 0px 0px 0px;
    }
  }

  // 5.用户之声
  .voice_customer {
    .content {
      display: flex;
      justify-content: space-between;
      margin-bottom: 40px;
      .li {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 383px;
        height: 151px;
        border-radius: 24px 24px 24px 24px;
        background-image: url(../../assets/image/home/yhzs_bg_1.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        .con {
          display: flex;
          align-items: center;
        }
        img {
          width: 29.25px;
          height: 29.25px;
          margin-right: 7px;
        }
      }
      .li2 {
        background-image: url(../../assets/image/home/yhzs_bg_2.png);
      }
      .li3 {
        background-image: url(../../assets/image/home/yhzs_bg_3.png);
      }
    }
    .danmaku_box {
      position: relative;
      min-height: 460px;
    }
    .danmaku-content {
      display: flex;
      flex-direction: column;
    }
    .danmaku-item {
      padding: 15px;
      box-sizing: border-box;
      width: 290px;
      height: 120px;
      background: #ffffff;
      box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.05);
      border-radius: 16px 16px 16px 16px;
      margin-bottom: 16px;
      .top {
        display: flex;
        justify-content: space-between;
      }
      .name {
        font-size: 18px;
        color: #100926;
      }
      .gender {
        font-size: 18px;
        color: #056de8;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 188px;
      }
      .text {
        font-size: 16px;
        line-height: 19px;
        text-align: left;
        margin-top: 12px;
        color: rgba(16, 9, 38, 0.4);
        white-space: wrap;
        -webkit-line-clamp: 3; /* 限制显示的行数为3行 */
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
      }
    }
  }
}
/deep/.swiper-pagination-bullet {
  background: #a6a6a6;
  opacity: 1;
}
/deep/.swiper-pagination-bullet-active {
  background-color: #fff;
}

.swiper-button-prev {
  left: 40px;
}
.swiper-button-prev:after,
.swiper-rtl .swiper-button-next:after {
  content: '';
}
.swiper-button-next {
  right: 40px;
}
.swiper-button-next:after,
.swiper-rtl .swiper-button-prev:after {
  content: '';
}
.swiper-pagination {
}
.el-table th {
  background-color: #f5f7fa !important;
}

.navigation_box_top {
  position: fixed;
  bottom: 200px;
  left: 40px;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 240px;

  .fix_title {
    display: flex;
    flex-direction: column;
    width: 56px;
    height: 137px;
    background: #056de8;
    box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.08);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
    font-size: 18px;
    color: #ffffff;
    line-height: 20px;
    cursor: pointer;
    span {
      writing-mode: vertical-lr; /* 垂直排列，从左到右 */
      letter-spacing: 5px; /* 字符间距 */
    }
    img {
      width: 8px;
      height: 15px;
      margin-top: 6px;
    }
  }
}
.navigation_box_top:hover .navigation_box {
  display: block;
}

.navigation_box {
  display: none;
  width: 140px;
  height: 240px;
  background: #ffffff;
  box-shadow: 0px 12px 32px 0px rgba(11, 6, 30, 0.08);
  border-radius: 12px 12px 12px 12px;
  overflow: hidden;
  .li {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgba(16, 9, 38, 0.4);
    height: 48px;
    line-height: 48px;
    cursor: pointer;
    box-sizing: border-box;
  }
  .li::after {
    content: '';
    width: 119px;
    border-bottom: 1px solid rgba(16, 9, 38, 0.1);
  }
  .li:nth-last-child(1)::after {
    border: none;
  }
  .li_title {
    font-size: 18px;
    color: #100926;
    font-weight: bold;
  }
  .li_active {
    background: rgba(16, 9, 38, 0.1);
    color: rgba(16, 9, 38, 1);
  }
}

.table_title {
  font-weight: bold;
  font-size: 16px;
  color: #000;
}

.blue_text {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 156px;
  height: 44px;
  border-radius: 12px 12px 12px 12px;
  border: 1px solid #056de8;
  margin: 0 auto;
  font-size: 16px;
  color: #056de8;
  cursor: pointer;
  img {
    width: 14px;
    height: 7px;
    margin-left: 8px;
  }
}
.blue_text:hover {
  background-color: #056de8;
  color: #fff;
}

/deep/ .el-table__header-wrapper {
  position: relative;
  z-index: 99;
}
/deep/.el-table__body-wrapper {
  cursor: pointer;
  position: static;
  z-index: 10;
  will-change: transform;
  animation: scrollUp var(--scroll-time) linear infinite;
  overflow: hidden !important;
}
@keyframes scrollUp {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(-100%); /* 向上滚动一个表格高度 */
  }
}
/* 鼠标悬停时暂停动画 */
/deep/ .el-table__body-wrapper.paused {
  animation-play-state: paused;
}
/deep/ .el-table {
  background-color: transparent;
}
</style>
